import axios from '../../axios/index.js'
import store from '../../../store/store.js'

// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched (access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}

export default {
  init () {
    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      // const { config, response: { status } } = error
      const { config, response } = error
      const originalRequest = config

      // if (status === 401) {
      if (response && response.status === 401) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true
          store.dispatch('auth/fetchAccessToken')
            .then((access_token) => {
              isAlreadyFetchingAccessToken = false
              onAccessTokenFetched(access_token)
            })
        }

        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber(access_token => {
            originalRequest.headers.Authorization = `Bearer ${access_token}`
            resolve(axios(originalRequest))
          })
        })
        return retryOriginalRequest
      }
      return Promise.reject(error)
    })
  },
  checkToken () {
    const token = localStorage.accessToken
    return axios.get('/user', {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  loginUser (payload) {
    console.log('login payload', payload)
    return axios.post('/api/signin', payload)
  },
  getCamImages (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/camera/frame', {
      headers:{
        Authorization: `${token}`
      },
      params: payload
    })
  },
  getConsecutiveImages (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/camera/frame/next', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  setCameraPtz (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/event/camera/ptz', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  setCameraRotation (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/event/camera/rotation', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getEventCamera (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/event/camera', {
      headers:{
        Authorization: `${token}`
      },
      params: payload
    })
  },
  getEvents (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/event/list', {
      headers:{
        Authorization: `${token}`
      },
      params: payload
    })
  },
  getLogsLast (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/logs/last', {
      headers:{
        Authorization: `${token}`
      },
      params: payload
    })
  },
  getEventsAll () {
    const token = localStorage.accessToken
    return axios.get('/api/event/listAll', {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getBolgeEvents () {
    const token = localStorage.accessToken
    return axios.get('/api/bolge/events', {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getEventDetails (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/event/details', {
      headers:{
        Authorization: `${token}`
      },
      params: payload
    })
  },
  getUser (id) {
    const token = localStorage.accessToken
    return axios.get(`/api/user?id=${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getUserList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/user/list', {
      headers:{
        Authorization: `${token}`
      },
      params: payload
    })
  },
  getUserValidation () {
    const token = localStorage.accessToken
    return axios.get('/api/user/validate', {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  deleteUser (id) {
    const token = localStorage.accessToken
    return axios.delete(`/api/user/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },

  addUser (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/user', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  editUser (payload) {
    const token = localStorage.accessToken
    return axios.put('/api/user', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  editEvent (payload) {
    const token = localStorage.accessToken
    return axios.put('/api/event', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  deleteEvent (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/event/delete', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  addBolge (payload) {
    const token = localStorage.accessToken
    console.log('addBolge', payload)
    return axios.post('/api/bolge', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  deleteBolge (id) {
    const token = localStorage.accessToken
    return axios.delete(`/api/bolge/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getBolge (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/bolge', {
      headers:{
        Authorization: `${token}`
      },
      params: payload
    })
  },
  updateBolge (payload) {
    const token = localStorage.accessToken
    return axios.put('/api/bolge', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getBolgeList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/bolge/list', {
      headers:{
        Authorization: `${token}`
      },
      params: payload
    })
  },

  addIsletme (payload) {
    const token = localStorage.accessToken
    console.log('addBolge', payload)
    return axios.post('/api/isletme', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  deleteIsletme (id) {
    const token = localStorage.accessToken
    return axios.delete(`/api/isletme/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getIsletme (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/isletme', {
      headers:{
        Authorization: `${token}`
      },
      params: payload
    })
  },
  updateIsletme (payload) {
    const token = localStorage.accessToken
    return axios.put('/api/isletme', payload, {
      headers: {
        Authorization: `${token}`
      }
    })
  },
  getIsletmeList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/isletme/list', {
      headers:{
        Authorization: `${token}`
      },
      params: payload
    })
  },

  addSeflik (payload) {
    const token = localStorage.accessToken
    console.log('addSeflik', payload)
    return axios.post('/api/seflik', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  deleteSeflik (id) {
    const token = localStorage.accessToken
    return axios.delete(`/api/seflik/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getSeflik () {},
  updateSeflik (payload) {
    const token = localStorage.accessToken
    console.log('editSeflik', payload)
    return axios.put('/api/seflik', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getSeflikList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/seflik/list', {
      headers:{
        Authorization: `${token}`
      },
      params: payload
    })
  },

  addKule (payload) {
    const token = localStorage.accessToken
    console.log('addKule', payload)
    return axios.post('/api/kule', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  editKule (payload) {
    const token = localStorage.accessToken
    console.log('editKule', payload)
    return axios.put('/api/kule', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  deleteKule (id) {
    const token = localStorage.accessToken
    return axios.delete(`/api/kule/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getKule () {},
  getKuleList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/kule/list', {
      headers:{
        Authorization: `${token}`
      },
      params: payload
    })
  },


  getKameraList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/camera/list', {
      headers:{
        Authorization: `${token}`
      },
      params: payload
    })
  },

  getKameraListAll (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/camera/listAll', {
      headers:{
        Authorization: `${token}`
      },
      params: payload
    })
  },
  getKuleAnalyze () {
    const token = localStorage.accessToken
    return axios.get('/api/kule/analyze', {
      headers:{
        Authorization: `${token}`
      }
    })
  },

  getStatusList () {
    const token = localStorage.accessToken
    return axios.get('/api/status/list', {
      headers:{
        Authorization: `${token}`
      }
    })
  },

  addKamera (payload) {
    const token = localStorage.accessToken
    console.log('addKamera', payload)
    return axios.post('/api/camera', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  addKameraCSV (payload) {
    const token = localStorage.accessToken
    console.log('addKamera', payload)
    return axios.post('/api/camera/csv', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  editKamera (payload) {
    const token = localStorage.accessToken
    console.log('editKamera', payload)
    return axios.put('/api/camera', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  deleteKamera (id) {
    const token = localStorage.accessToken
    return axios.delete(`/api/camera/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  }

}
